import { theme } from 'config';

type PieLabelProps = {
  cx: number;
  cy: number;
  index: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
};

type LapsedActivityColors = {
  [key: string]: string;
};

const {
  seafoamGreen,
  softSeafoamGreen,
  coral,
  softCoral,
  deepPurple,
  violet,
  softViolet,
} = theme;

const RATIO_CHART_LEGEND = [
  { title: '<14 days', type: '<14 Day Lapsed', color: softSeafoamGreen },
  { title: '15-29 days', type: '15-29 Day Lapsed', color: seafoamGreen },
  { title: '30-59 days', type: '30-59 Day Lapsed', color: softCoral },
  { title: '60-89 days', type: '60-89 Day Lapsed', color: coral },
  { title: '90-179 days', type: '90-179 Day Lapsed', color: softViolet },
  { title: '180-364 days', type: '180-364 Day Lapsed', color: violet },
  { title: '365 days', type: '365 Day Lapsed and Net New', color: deepPurple },
];

const lapsedActivityColors: LapsedActivityColors = {
  '<14 Day Lapsed': softSeafoamGreen,
  '15-29 Day Lapsed': seafoamGreen,
  '30-59 Day Lapsed': softCoral,
  '60-89 Day Lapsed': coral,
  '90-179 Day Lapsed': softViolet,
  '180-364 Day Lapsed': violet,
  '365 Day Lapsed and Net New': deepPurple,
};

const sortOrder = Object.keys(lapsedActivityColors);

export { RATIO_CHART_LEGEND, sortOrder, PieLabelProps, lapsedActivityColors };
